module.exports = __webpack_public_path__ + "img/cross.c1f8b774.svg";